var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 69.61999999999999",
    style: {
      maxHeight: 500
    },
    width: 70,
    height: 69.61999999999999,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#17233B",
    d: "M29.0828 3.35387C32.7533 1.27343 37.2467 1.27343 40.9172 3.35387L50.225 8.62953L59.4478 14.0525C63.0847 16.191 65.3314 20.0824 65.365 24.3014L65.45 35L65.365 45.6986C65.3314 49.9176 63.0847 53.809 59.4478 55.9475L50.225 61.3705L40.9172 66.6461C37.2467 68.7266 32.7533 68.7266 29.0828 66.6461L19.775 61.3705L10.5522 55.9475C6.91528 53.809 4.66858 49.9176 4.63505 45.6986L4.55 35L4.63505 24.3014C4.66858 20.0824 6.91529 16.191 10.5522 14.0525L19.775 8.62953L29.0828 3.35387Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    stroke: "#EDFF6B",
    d: "M25 25V42C25 43.66 26.34 45 28 45H45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    stroke: "#EDFF6B",
    d: "M28 40L32.59 34.64C33.35 33.76 34.7 33.7 35.52 34.53L36.47 35.48C37.29 36.3 38.64 36.25 39.4 35.37L44 30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.4e75b210e7cf0b3d8acd9374e893ea2c.svg";
export { ForwardRef as ReactComponent };